import { PaperclipIcon } from "@storytell/bsky-icons";
import type { Component } from "solid-js";
import type { UseFileUploadReturn } from "~/lib/file-upload";

interface FileDropzoneProps {
  fileUpload?: UseFileUploadReturn;
}

/**
 * File dropzone overlay component that appears during drag operations
 * Client-side only component - no SSR rendering
 */
export const FileDropzone: Component<FileDropzoneProps> = (props) => {
  return (
    <div class="absolute inset-0 flex items-center justify-center z-20 pointer-events-none">
      <div class="text-center w-full max-w-md mx-auto px-4">
        <div
          class="inline-flex items-center justify-center w-10 h-10 rounded-full mb-1"
          style={{
            background: "linear-gradient(135deg, rgba(0,0,0,0.1), rgba(0,0,0,0.05))",
            "box-shadow": "inset 0 2px 4px rgba(0,0,0,0.3), inset 0 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          <PaperclipIcon class="w-5 h-5 text-brand/60" />
        </div>
        <p class="text-sm text-primary-text/60">Drop files here</p>
      </div>
    </div>
  );
};
